// extracted by mini-css-extract-plugin
module.exports = {"overlay":"overlay___1-oC0","clip":"clip___HQspb","container":"container___3EF_R"};